// extracted by css-extract-rspack-plugin
export default {"FilterFooterRoot":"FilterPickerFooter-module__FilterFooterRoot___FeGdo"};